class localhostSettings { }
const win:any = window;

if (win.location.href.includes("localhost")) {
  win["lang"] = "en";
  // win["lang"] = "ar";
  // document.documentElement.dir = "rtl"; 
}
if (win["lang"] !== undefined) {
  document.documentElement.lang = win["lang"];
} else {
  win["lang"] = document.documentElement.lang;
  console.error("win['lang'] is undefined");
}

console.log(document.documentElement.lang);
export default localhostSettings;